import { BaseCMS, PageHeader } from 'asumsi-components';
import { Breadcrumb, MenuSidebar } from 'components';
import React, { Fragment } from 'react';
import { Typography } from "antd";
import { clearAllCookie } from '@helpers/cookies';
const { Text } = Typography;

interface IProps {
  breadcrumb?: any;
  children?: any;
  history?: any;
  documentTitle?: string;
  pageTitle?: string;
  notes?: string;
  pageIcon?: string;
}

export const LayoutCMSComponent = (props: IProps) => {
  const title = (
    <Fragment>
      <span>CMS {process.env.REACT_APP_PROJECT}</span>
    </Fragment>
  );

  const logout = () => {
    clearAllCookie();
    window.location.href = `${process.env.REACT_APP_WEB_URL}`;
  }
  return (
    <BaseCMS
      title={title}
      documentTitle={props.documentTitle}
      navigation={<MenuSidebar />}
      history={props.history}
      username={"User"}
      divisiName={""}
      onClickLogOut={logout}
    >
      {props.breadcrumb ? <Breadcrumb>{props.breadcrumb}</Breadcrumb> : null}
      <PageHeader title={props.pageTitle} icon={props.pageIcon} />
      <div className="asumsi-header-notes">
        <Text type="secondary">{props.notes}</Text>
      </div>
      {props.children}
    </BaseCMS>
  );
};

export default LayoutCMSComponent;



// WEBPACK FOOTER //
// ./src/components/templates/layout/component.tsx